import { render, staticRenderFns } from "./root-layout.vue?vue&type=template&id=49a3e545&"
import script from "./root-layout.vue?vue&type=script&lang=js&"
export * from "./root-layout.vue?vue&type=script&lang=js&"
import style0 from "./root-layout.vue?vue&type=style&index=0&id=49a3e545&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports